@if (showDisclaimer$ | async) {
  <div id="disclaimer" class="sh-fixed-footer">
    @if (disclaimerContent$ | async; as disclaimerContent) {
      <div class="sh-notice-panel">
        <h4 class="sh-notice-panel__title">
          <sh-html-parser [message]="disclaimerContent.title"></sh-html-parser>
        </h4>
        <div class="sh-notice-panel__content">
          @for (section of disclaimerContent.sections; track section) {
            <div>
              @if (section.sectionTitle) {
                <h5>
                  <sh-html-parser [message]="section.sectionTitle"></sh-html-parser>
                </h5>
              }
              @for (paragraph of section.paragraphs; track paragraph) {
                <p>
                  <span [innerHtml]="paragraph"></span>
                </p>
              }
            </div>
          }
          <ul class="sh-action-group -sh-align-end">
            @if (disclaimerLink$ | async; as link) {
              <li class="sh-action-group__item">
                <sh-action-item [item]="link" class="sh-action-group__item__action"></sh-action-item>
              </li>
            }
            @if (acceptButton$ | async; as acceptButton) {
              <li class="sh-action-group__item">
                <sh-action-item [item]="acceptButton" class="sh-action-group__item__action"></sh-action-item>
              </li>
            }
          </ul>
        </div>
      </div>
    } @else {
      <div class="sh-notice-panel">
        <div class="sh-notice-panel__content">
          <sh-notification [type]="notificationType.Error" [message]="'errors.translation-not-found' | translate" [icon]="'delete'"></sh-notification>
        </div>
      </div>
    }
  </div>
}

